import { SET_PRINT_MODE } from '../types/print.types';

export const setPrintMode = (mode: boolean) => {
    return {
        type: SET_PRINT_MODE,
        payload: mode
    };
}